import escapeHtml from 'escape-html'
import { Text } from 'slate'

// JWT Token parsing utility
export const parseJWTToken = (token) => {
  try {
    if (!token) return null;

    // JWT tokens have 3 parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // Decode the payload (second part)
    const payload = parts[1];
    // Add padding if needed for base64 decoding
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
    const decodedPayload = atob(paddedPayload);
    const parsedPayload = JSON.parse(decodedPayload);

    return {
      survey_id: parsedPayload.survey_id,
      type: parsedPayload.type, // 'email' or 'link'
      collector_id: parsedPayload.collector_id,
      email: parsedPayload.email // only present for EMAIL type
    };
  } catch (error) {
    console.error('Failed to parse JWT token:', error);
    return null;
  }
};

export const serialize = (node) => {
  let nodeText = escapeHtml(node.text)
  if (Text.isText(node)) {
    if (node['bold']) {
      nodeText = `<strong>` + nodeText + `</strong>`
    }

    if (node['italic']) {
      nodeText = `<em>` + nodeText + `</em>`
    }

    if (node['underlined']) {
      nodeText = `<u>` + nodeText + `</u>`
    }
    // Other marks should go here like above

    return nodeText
  }

  if (Array.isArray(node)) {
    return node.map((subNode) => serializeSubNode(subNode)).join('')
  }

  return serializeSubNode(node)
}

const serializeSubNode = (node) => {
  const children = node.children.map((n) => serialize(n)).join('')
  switch (node.type) {
    case 'link':
      return `<a href="${escapeHtml(node.url)}">${children}</a>`
    default:
      return `<p>${children}</p>`
  }
}
